import RectangleButton from "@/components/molecules/rectangleButton";
import Description from "./description";
import ImageSmall from "./imageSmall";
import ImageBig from "./imageBig";

const Content = ({
  imageSmall,
  imageBig,
  description,
  leftCtaButton,
  rightCtaButton,
}) => {
  return (
    <div className="relative w-full grid grid-cols-1 lg:grid-cols-2 mt-mediumMobile lg:mt-mediumDesktop gap-y-smallMobile lg:gap-x-[40px]">
      <div className="order-2 lg:order-1 relative w-full max-w-[507px] flex flex-col justify-between">
        <div className="relative w-full">
          <Description description={description} />
          <div className="relative w-full flex flex-wrap gap-[20px] md:gap-[34px] mt-smallDesktop lg:mt-[30px]">
            <RectangleButton
              name={leftCtaButton.name}
              link={leftCtaButton.link}
              target="_blank"
              className="block"
            />
            <RectangleButton
              name={rightCtaButton.name}
              link={rightCtaButton.link}
              target="_blank"
              className="block"
            />
          </div>
        </div>
        <ImageSmall image={imageSmall} />
      </div>
      <ImageBig image={imageBig} />
    </div>
  );
};

export default Content;
